import { config } from "@virtu/config";

export default function getShopUrl() {
    return config.get().authenticationServerUrl || "http://stubbed_shop";
}
